import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {EnglishToPersian} from "numeral-convert";
import {toFarsiNumber} from "../../cudtom-hooks/en-to-persian";
import {callApiAgain, showPopUp, updatePending} from "../common-states/commonStatesSlice";

const config = {
    headers: {Authorization: `Token ${localStorage.getItem('token')}`}
}

export const getRequests = createAsyncThunk("request/getRequests", async(data) => {
    const {searchParam, waterType, pageNum, dispatch} = data
    dispatch(updatePending(true))
    let bodyArray = [];
    await axios.get(`${(searchParam && searchParam.includes('tanker_request_id')) ? `https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request?${searchParam}`
        : (searchParam && searchParam.includes('city_id')) ? `https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/${pageNum}?${searchParam}&water_type=${waterType}`
            : `https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/${pageNum}?water_type=${waterType}`}`, config)
        .then((res) => {
            let stylesArray = [];
            function storeAllData(item){
                let registerDate = new Date(item.created_at).toLocaleDateString('fa-IR');
                let registerTime = EnglishToPersian(item.created_at?.slice(11));
                let deliverDate, deliverTime;
                if(item.nomad_confirmed_at){
                    deliverDate = new Date(item.nomad_confirmed_at).toLocaleDateString('fa-IR');
                    deliverTime = EnglishToPersian(item.nomad_confirmed_at.slice(11));
                }
                let styleObj = {color: 'white', fontSize: '0.7em', backgroundColor: (item.is_confirmed_by_user ? 'mediumseagreen' : item.is_rejected ? 'orange' : item.driver ? 'DarkTurquoise ' : 'crimson')}
                stylesArray = [...stylesArray, styleObj]
                bodyArray = [...bodyArray, [<i className="fa fa-trash delete" onClick={() => dispatch(deleteRequest({reqId: item.tanker_request_id, dispatch}))}></i>,
                    <i className="fa fa-edit edit" onClick={() => dispatch(setRequestInfo({obj: item, type: 'showEditForm'}))}></i>,
                    <i className="fa fa-file-text-o records" onClick={() => dispatch(setRequestInfo({obj: item, type: 'showHistory'}))}></i>,
                    (deliverTime ? deliverTime : '-'), (deliverDate ? deliverDate : '-'), registerTime, registerDate, toFarsiNumber(item.tanker_request_id), toFarsiNumber(item.region), item.city,
                    toFarsiNumber(item.nomad.mobiles[0].mobile), item.nomad.name, (item.is_confirmed_by_user ? 'تایید تحویل کاربر' : item.is_rejected ? 'رد شده' : item.driver ? 'اختصاص راننده' : 'بررسی نشده')]];
            }
            if(Array.isArray(res.data)){ //When we have more than one item in our response.
                res.data.forEach(item => {
                    storeAllData(item)
                })
            }
            else if(typeof res.data !== 'string'){ //When we have one item in our response, when return response includes just one item or when search is based on code(uniq) or it is city but response includes just one city. And it might be an empty string when there isn't any response, so we check it because we don't want to call function with empty string
                console.log(res.data)
                storeAllData(res.data)
                //This if statement is to check if we need to change waterType btn or no, when search is based on code, cause, it might be searched from other type of water.
                if(waterType !== res.data.water_type){
                    dispatch(setWaterType(res.data.water_type))
                }
            }
            dispatch(updatePending(false))
            dispatch(setRequestStatus({styles: stylesArray}))
        })
        .catch(() => {
            dispatch(updatePending(false))
        })
    return bodyArray
})

export const getDriversInfo = createAsyncThunk("request/getDriversInfo", async() => {
    let drivers = [];
    await axios.get("https://demo.khedmatashayer-kj.ir/api/v1/driver/1", config)
        .then(res => {
            drivers = res.data.map(item => {
                return {name: item.name, id: item.driver_id}
            })
            console.log(res.data)
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return drivers
})

export const deleteRequest = createAsyncThunk("request/deleteRequest", async(data) => {
    const {reqId, dispatch} = data
    let r = window.confirm("آیا برای حذف این درخواست کاربر اطمینان دارید؟");
    if(r === true){
        axios.delete(`https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/${reqId}`, config)
            .then(res => {
                console.log(res.data)
                dispatch(callApiAgain(true))
                alert('درخواست مرود نظر با موفقیت حذف شد!')
            })
            .catch(() => {
                alert('خطا در برقراری ارتباط با سرور')
            })
    }
})

export const addRequest = createAsyncThunk("request/addRequest", async(allData) => {
    const {data, dispatch, waterType, formikWaterType} = allData
    let error = '';
    await axios.post('https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request', data, config)
        .then((res) => {
            if(res.data.message.includes("error : {'nomad_id':")){
                error = 'یک کد ملی عشایر موجود وارد کنید';
            }
            else if(res.data.message.includes("error : {'water_volume':")){
                error = 'حجم تانکر میتواند کمتر یا مساوی با 65535 لیتر باشد';
            }
            if(error === ''){
                dispatch(showPopUp({type: 'showForm', value: false}))
                dispatch(callApiAgain(true))
                if(waterType !== formikWaterType){
                    dispatch(setWaterType(formikWaterType))
                }
            }
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return error
})

export const editRequest = createAsyncThunk("request/editRequest", async(data) => {
    const {commonData, code, registerBtnType, dispatch} = data
    if(registerBtnType === 'ثبت اطلاعات'){
        await axios.post('https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/allocate-driver', commonData, config)
            .then(res => {
                dispatch(callApiAgain(true))
                dispatch(showPopUp({type: 'showEditForm', value: false}))
                alert(res.data.message)
            })
            .catch(() => {
                alert('داده های خواسته شده را تکمیل کنید!')
            })
    }
    else if(registerBtnType === 'ویرایش اطلاعات' || registerBtnType === 'تایید تحویل' || registerBtnType === 'رد درخواست'){
        let r = registerBtnType === 'تایید تحویل' ? window.confirm('آیا از تایید تحویل این درخواست مطمئن هستید؟') : registerBtnType === 'رد درخواست' ? window.confirm('آیا از رد این درخواست اطمینان دارید؟') : '';
        if(registerBtnType === 'ویرایش اطلاعات' || r === true){
            axios.put(`https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/${code}`, commonData, config)
                .then(res => {
                    dispatch(callApiAgain(true))
                    dispatch(showPopUp({type: 'showEditForm', value: false}))
                    registerBtnType === 'تایید تحویل' ? alert('تایید تحویل این درخواست با موفقیت ثبت شد.') : registerBtnType === 'رد درخواست' ? alert('رد درخواست ثبت شد.') : alert(res.data.message)
                })
                .catch(() => {
                    alert('خطا در برقراری ارتباط با سرور')
                })
        }
    }
})

export const requestSlice = createSlice({
    name: 'request',
    initialState: {
        bodyArray: [],
        requestStatus: {
            styles: [],
            isRejected: false,
            error: ''
        },
        waterType: 1,
        selectedRequest: {obj: null, type: ''},
        driversInfo: []
    },
    reducers: {
        setRequestStatus: (state, action) => {
            state.requestStatus = {...state.requestStatus, ...action.payload}
        },
        setWaterType: (state, action) => {
            state.waterType = action.payload
        },
        setRequestInfo: (state, action) => {
            state.selectedRequest = action.payload
        }
    },
    extraReducers(builder){
        builder
            .addCase(getRequests.fulfilled, (state, action) => {
                state.bodyArray = action.payload
            })
            .addCase(addRequest.fulfilled, (state, action) => {
                state.requestStatus = {...state.requestStatus, error: action.payload}
            })
            .addCase(getDriversInfo.fulfilled, (state, action) => {
                state.driversInfo = action.payload
            })
    }
})

export const {setRequestStatus, setWaterType, setRequestInfo} = requestSlice.actions
export const selectRequestBodyArray = state => state.request.bodyArray
export const selectRequestStyles = state => state.request.requestStatus.styles
export const selectRequestIsRejected = state => state.request.requestStatus.isRejected
export const selectWaterType = state => state.request.waterType
export const selectSelectedRequest = state => state.request.selectedRequest
export const selectRequestError = state => state.request.requestStatus.error
export const selectDriversInfo = state => state.request.driversInfo

export default requestSlice.reducer